<template>
  <div>
    <div class="kit__utils__heading">
      <h5>
        <span class="mr-3">Gestión de Asignaturas</span>
      </h5>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col">
            <h5 class="mb-4">
              <strong>Crear asignatura</strong>
            </h5>
          </div>
        </div>
        <b-form @submit="save" @reset="onReset">
          <div class="row">
            <div class="col-md-6">
              <b-form-group id="input-group-1" label="Nombre:" label-for="input-1" description="Ejemplo: Geometría">
                <b-form-input id="input-1" v-model="form.name" required placeholder="Ingrese el nombre de la asignatura"></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group id="input-group-2" label="Descripción:" label-for="input-2" description="">
                <b-form-input id="input-2" v-model="form.description" placeholder="Ingrese una descripción"></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <b-form-group id="input-group-3" label="Área:" label-for="input-3" description="Seleccione el área al que pertenece la asignatura">
                <b-form-select v-model="form.areaSelected" required :options="areas"></b-form-select>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-button type="submit" variant="primary" class="mr-2 mb-3 mt-4">Guardar</b-button>
            </div>
          </div>
        </b-form>
        <a-divider />
        <div class="row">
          <div class="col">
            <h5 class="mb-4">
              <strong>Lista de asignaturas</strong>
            </h5>
          </div>
        </div>
        <div class="row">
          <div class="col">
            <h5 class="mb-4">
              <a-table :columns="columns" :dataSource="data" rowKey="id">
                <div slot="action" slot-scope="group">
                  <a @click="() => openModal(group)">Editar</a>
                  <!-- <a-popconfirm title="¿Desea eliminar este grupo?" okText="Si" cancelText="No" @confirm="remove">
                    <a>Eliminar</a>
                  </a-popconfirm> -->
                </div>
              </a-table>
            </h5>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="edit-group" ref="modal" title="Editar asignatura" hide-footer>
      <b-form @submit="edit" ref="todoform">

        <b-form-group id="input-group-1-edit" label="Nombre:" label-for="input-1" description="Ejemplo: Cuarto A">
          <b-form-input id="input-1-edit" v-model="subjectToEdit.name" required placeholder="Ingrese el nombre de la asignatura"></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-2-edit" label="Descripción:" label-for="input-2" >
          <b-form-input id="input-1-edit" v-model="subjectToEdit.description" placeholder="Ingrese una descripción de la asignatura"></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-3-edit" label="Grado:" label-for="input-3" description="Seleccione el grado al que pertenece la asignatura">
          <b-form-select v-model="subjectToEdit.idArea" required :options="areas"></b-form-select>
        </b-form-group>

        <b-button @click="$bvModal.hide('edit-group')" variant="secondary" size="sm" class="mr-2 mb-3 mt-3">Cancelar</b-button>
        <b-button type="submit" variant="primary" class="mr-2 mb-3 mt-3">Guardar</b-button>
      </b-form>
    </b-modal>
  </div>
</template>
<script>
import apiClient from '@/services/axios'
import axios from 'axios'
import { mapState } from 'vuex'
import store from 'store'
import { showErrorMessage } from '@/services/utilities'

const columns = [
  { title: 'Código', dataIndex: 'id', key: 'id' },
  { title: 'Asignatura', dataIndex: 'name', key: 'name' },
  { title: 'Descripción', dataIndex: 'description', key: 'description' },
  { title: 'Area', dataIndex: 'textIdArea', key: 'area' },
  { title: 'Acción', dataIndex: '', key: 'x', scopedSlots: { customRender: 'action' } },
]

export default {
  name: 'ManagementSubject',
  data() {
    return {
      form: {
        name: '',
        description: '',
        areaSelected: null,
      },
      subjectToEdit: {
        name: '',
        description: '',
        areaSelected: null,
      },
      data: null,
      columns,
      areas: null,
    }
  },
  computed: {
    ...mapState(['user']),
  },
  beforeRouteEnter (to, from, next) {
    const userStorage = JSON.parse(store.get('userData'))

    function getAreas() {
      return apiClient.get('/areas')
    }

    function getSubjects() {
      return apiClient.get('/subjects', {
        params: {
          idSchool: userStorage.idSchool,
          idYear: userStorage.currentYear,
        },
      })
    }
    axios.all([getAreas(), getSubjects()])
      .then(axios.spread(function (areas, subjects) {
        next((vm) => {
          const areasData = areas.data.results.rows.map(x => {
            return {
              value: x.id,
              text: x.id + ' - ' + x.name,
            }
          })
          areasData.unshift({ value: null, text: 'Seleccione un área' })

          const subjectsData = subjects.data.map(x => {
            x.textIdArea = x.idArea + ' - ' + x.area.name
            return x
          })
          vm.setDataAreas(null, areasData)
          vm.setDataSubjects(null, subjectsData)
        })
      }))
      .catch(err => {
        next((vm) => {
          vm.setDataAreas(err, [])
          vm.setDataSubjects(err, [])
        })
      })
  },
  methods: {
    setDataAreas (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString() // TODO Mostrar error
      } else {
        this.areas = data
      }
    },
    setDataSubjects (err, data) { // Carga la informacion del beforeRouteEnter
      if (err) {
        this.error = err.toString() // TODO Mostrar error
      } else {
        this.data = data
      }
    },
    save(evt) { // Guarda una asignatura llamando a la API
      evt.preventDefault()
      this.form.idSchool = this.$store.state.user.idSchool
      this.form.idYear = this.$store.state.user.currentYear
      this.form.idArea = this.form.areaSelected
      apiClient.post('/subjects', this.form).then(response => {
        response.data.textIdArea = response.data.idArea + ' - ' + response.data.area
        this.data.push(response.data)
        this.form.name = ''
        this.form.description = ''
        this.form.areaSelected = null
        this.$notification.success({
          message: 'Creado exitosamente',
          description: `La asignatura ${response.data.name} fue creada con éxito.`,
        })
      }).catch(err => {
        this.$notification.success({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(err),
        })
      })
    },
    remove() { // Elimina una asignatura - Aun no implementado
      alert('Eliminado :D') // TODO Implementar eliminacion
    },
    openModal(groupIn) { // Abre el modal para editar la asignatura
      this.subjectToEdit = Object.assign({}, groupIn)
      this.$bvModal.show('edit-group')
    },
    edit(evt) { // Edita una asignatura llamando a la API
      evt.preventDefault()
      apiClient.patch(`/subjects/${this.subjectToEdit.id}`, this.subjectToEdit).then(response => {
        this.data = this.data.map(x => {
          if (x.id === response.data.id) {
            response.data.textIdArea = response.data.idArea + ' - ' + response.data.area
            return response.data
          } else {
            return x
          }
        })
        this.$notification.success({
          message: 'Modificación exitosa',
          description:
            `Se modificó la asignatura ${response.data.name} correctamente.`,
        })
        this.$bvModal.hide('edit-group')
      }).catch(err => {
        this.$notification.success({
          message: 'Ooops ocurrió un error',
          description: showErrorMessage(err),
        })
      })
    },
    onReset(evt) {
      evt.preventDefault()
      // Reset our form values
      this.form.email = ''
      this.form.name = ''
      this.form.food = null
      this.form.checked = []
    },
  },
}
</script>
